import { useFlags } from 'launchdarkly-react-client-sdk';
import { getQriServiceUrl } from '../util/QriUrlUtils';

export const useQriServiceUrl = (): string => {
  const { mtbeNewStagingDomain } = useFlags();
  return getQriServiceUrl(Boolean(mtbeNewStagingDomain));
};
